export default __webpack_public_path__ + "static/media/art-red-2.6ad5dc1f.png";